import modal from './Modal';

export default function directBuyModal() {
  return {
    ...modal(),
  };
}
